"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var surveyscreeners = [_utils.screeners.WHO5];
var causalAnalysisQuestionScale = ["Overloaded with work", "Current project not engaging/interesting", "Lacking resources to do job", "Lacking support to do job", "Uncertainty if my job is secure", "Not paid enough for the work I do", "Frustrated with a colleague/colleagues", "Family issue", "Unfair/disrespectful treatment by management", "Bullying", "Not sure what's expected of me for task/role/project", "Not recognised enough for the work I do", "Lacking friendships/peer support at work", "Lacking opportunities to work on what I like", "None of these options"];
var likertLikeScale = ["At no time", "Some of the time", "Less than half the time", "More than half the time", "Most of the time", "All of the time"];
var questions = (0, _screeners.expandscreeners)([_utils.screeners.WHO5, {
  extraText: "In the past month,",
  batteryId: "WHO5",
  type: "multiSkip",
  meta: {
    answerLabel: "My challenges are...",
    skipLabel: "I have no challenges at work",
    responsePrefix: "My challenges are: ",
    noResponsePrefix: "I have no challenges at work"
  },
  prompt: "Have any of the following <b>made it hard for you to work<br /> effectively</b> (you can choose multiple options)",
  skipLabel: "I have no challenges at work",
  options: causalAnalysisQuestionScale
}]);
exports.questions = questions;

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answers[screener], screener); // answer: {WHO5: Array, STRESS: Array}

    filteredQuestions.forEach(function (q, i) {
      if (!q.key) return;
      results[q.key] = q.eval(answers[screener][i]);
    });
  });
  return results;
};

exports.analysis = analysis;